// Overrides klaviyo form scaling on mobile
function init(){
  const midyearPopupContentObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if(node.getAttribute("role") === "dialog" && node.classList.contains("kl-private-reset-css-Xuajs1")){
            node.style.transform = "scale(1)"
            window.addEventListener('resize', () => {
              node.style.transform = "scale(1)"
            })
            break;
          }
        }
      }
    }
  })
  
  const midyearPopupObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          const klaviyoPopup = typeof node.querySelector === 'function' ? node.querySelector(".kl-private-reset-css-Xuajs1") : false
          if(klaviyoPopup){
            midyearPopupContentObserver.observe(klaviyoPopup,  { childList: true });            
          }
        }
      }
    }
  })
    
  // Start observing the body for changes
  midyearPopupObserver.observe(document.body, { childList: true })
}

init()